import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, inject, input, output, viewChildren } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { OrderData } from '@lfw/roesberg.liveforms.core';
import { TranslatePipe } from '@ngx-translate/core';
import { OpenInNewTabDirective } from '../../../route/open-in-new-tab.directive';
import { MenuVerticalDividerComponent } from '../../../shared/components/menu-vertical-divider.component';

@Component({
  selector: 'lfw-online-order-list-actions',
  templateUrl: './online-order-list-actions.component.html',
  styleUrls: ['./online-order-list-actions.component.css'],
  imports: [
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    TranslatePipe,
    RouterModule,
    MenuVerticalDividerComponent,
    MatTooltipModule,
    OpenInNewTabDirective
  ]
})
export class OnlineOrdersListActionsComponent {
  order = input.required<OrderData>();
  userCanCancel = input.required();
  finishOrder = output<OrderData>();
  checkoutOrder = output<OrderData>();
  cancelOrder = output<OrderData>();

  menuTriggers = viewChildren(MatMenuTrigger);
  private readonly breakpointObserver = inject(BreakpointObserver);

  constructor() {
    this.breakpointObserver
      .observe(`(width >= 48rem)`)
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        this.menuTriggers().forEach((trigger) => trigger.closeMenu());
      });
  }
}
